import {
  IAccessory,
  IAccessoryCategory,
  ICharging,
  IChargingCategory,
} from 'interfaces/buildAndPrice';

// any because rulesengines data is not typed
export function parseAccessoryData(acc: any) {
  const price =
    acc.PriceBundle || acc.OptionPrice || acc.priceBundle || acc.price;
  const name = acc.OptionName || acc.name || ''; //rulesEngine || service
  return {
    opCode: acc.OpCode || acc.opCode, //rulesEngine || service
    name: name.replace(/–/g, '-'),
    enName: acc.enName?.replace(/–/g, '-') || '',
    price: price ? Math.ceil(price) : 0,
    image: acc.Thumb || acc.thumbnail,
    isPackage: false,
    iriZOrder: acc.iriZOrder,
    hasIRIAssets: acc.hasIRIAssets,
    categoryName: acc.categoryName,
    includedBy: acc.IncludedByList || acc.rules?.includedBy || [],
    showInIri: acc.showInIri,
  };
}

export function addCategoryNameToAccessory(
  accessoryList: IAccessory[],
  categoryList: IAccessoryCategory[]
) {
  return accessoryList.map((acc) => {
    const category = categoryList.find((categ) => categ.id === acc.category);

    return { ...acc, categoryName: category?.name };
  });
}

export function addCategoryNameToCharging(
  accessoryList: ICharging[],
  categoryList: IChargingCategory[]
) {
  return accessoryList.map((acc) => {
    const category = categoryList.find((categ) => categ.id === acc.category);

    return { ...acc, categoryName: category?.name };
  });
}
